import "core-js/modules/es.object.from-entries.js";
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import { appConfig } from "../../utils/app-config";
import { isTruthy } from "../../utils/isTruthy";
export var isNotSupportedMime = function isNotSupportedMime(mime, src) {
  if (!mime || !src) {
    return true;
  }
  return ["image/gif", "image/svg+xml", "image/svg"].includes(mime) || src.match(/\.gif|\.svg/i);
};
var getSizes = function getSizes(size) {
  switch (size) {
    case "small":
      return "(max-width: 750px) 100vw, (max-width: 900px) 60vw, (max-width: 1050px) 42vw";
    case "medium":
      return "(max-width: 750px) 100vw, (max-width: 900px) 80vw, (max-width: 1050px) 56vw";
    case "large":
      return "(max-width: 750px) 100vw, (max-width: 900px) 100vw, (max-width: 1050px) 70vw";
    default:
      return undefined;
  }
};
var getSrcSet = function getSrcSet(styles) {
  return styles ? Object.values(styles).map(function (style) {
    return "".concat(style === null || style === void 0 ? void 0 : style.url, " ").concat(style === null || style === void 0 ? void 0 : style.width, "w");
  }).join(",") : undefined;
};
export var Image = function Image(_param) {
  var _param_fit = _param.fit,
    fit = _param_fit === void 0 ? false : _param_fit,
    sizes = _param.sizes,
    src = _param.src,
    size = _param.size,
    styles = _param.styles,
    alt = _param.alt,
    className = _param.className,
    style = _param.style,
    filemime = _param.filemime,
    _param_loading = _param.loading,
    loading = _param_loading === void 0 ? "lazy" : _param_loading,
    props = _object_without_properties(_param, ["fit", "sizes", "src", "size", "styles", "alt", "className", "style", "filemime", "loading"]);
  var isGif = isNotSupportedMime(filemime, src);
  var imageStyle = fit ? _object_spread({}, style, {
    height: "100%",
    width: "100%",
    objectFit: "cover"
  }) : style;
  return isGif ? /*#__PURE__*/React.createElement("img", {
    className: className,
    alt: alt,
    src: src,
    style: imageStyle,
    loading: loading
  }) : /*#__PURE__*/React.createElement("img", _object_spread({
    alt: alt,
    sizes: sizes || getSizes(size),
    srcSet: getSrcSet(styles),
    src: src || "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    className: className,
    style: imageStyle,
    loading: loading
  }, props));
};
// Applies to MediaImage | MediaIcon
export var getImageStyleUrl = function getImageStyleUrl(image, styleName) {
  var styles = image === null || image === void 0 ? void 0 : image.styles;
  return getUrlFromStyles(styles, styleName);
};
// Generic helper that can also apply to Image fields.
export var getUrlFromStyles = function getUrlFromStyles(styles, styleName) {
  var style = styles === null || styles === void 0 ? void 0 : styles.find(function (imageStyle) {
    return imageStyle.id == styleName;
  });
  if (style !== undefined) {
    var url = style.url;
    return assetUrl(url);
  }
  return undefined;
};
export var assetUrl = function assetUrl(url) {
  // If the url is relative and we have an assests domain defined, then we will
  // load the resource from the assets domain.
  var assetsDomain = appConfig().assetsDomain;
  if (url.startsWith("/") && assetsDomain) {
    return "".concat(assetsDomain).concat(url);
  }
  return url;
};
export var getImageSrc = function getImageSrc(image, src) {
  if (!image) {
    return;
  }
  return isNotSupportedMime(image === null || image === void 0 ? void 0 : image.mimeType, image === null || image === void 0 ? void 0 : image.url) ? image === null || image === void 0 ? void 0 : image.url : src;
};
export var transformImageFragmentToProps = function transformImageFragmentToProps(image, imageStyles) {
  var styles = Object.fromEntries((image === null || image === void 0 ? void 0 : image.styles.filter(isTruthy).filter(function (s) {
    return !imageStyles || imageStyles.includes(s.id);
  }).map(function (s) {
    return [s.id, s];
  })) || []);
  return {
    src: assetUrl(getImageSrc(image, image === null || image === void 0 ? void 0 : image.url) || ""),
    // @todo probably use mimeType as other transform functions are using it
    filemime: image === null || image === void 0 ? void 0 : image.mimeType,
    alt: image === null || image === void 0 ? void 0 : image.alt,
    title: image === null || image === void 0 ? void 0 : image.title,
    width: image === null || image === void 0 ? void 0 : image.width,
    height: image === null || image === void 0 ? void 0 : image.height,
    styles: styles
  };
};